<h2 mat-dialog-title>Decline Recording</h2>
<mat-dialog-content class="dialog-content">
  <p class="dialog-intro">
    A reason is required. The uploader sees it as the first message in this station's feedback thread.
  </p>

  <div class="recording-name-block">
    <span class="field-label">Recording name</span>
    <p class="recording-name-value">{{ recordingName }}</p>
  </div>

  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="full-width"
    subscriptSizing="dynamic">
    <mat-label>Reason for decline</mat-label>
    <textarea
      matInput
      [(ngModel)]="reason"
      name="declineReason"
      rows="4"
      required
      [maxlength]="maxChars"
      [disabled]="sending"
      placeholder="What should change before this recording can be approved?"></textarea>
    <mat-hint align="end">{{ reason.trim().length }} / {{ maxChars }}</mat-hint>
  </mat-form-field>

  @if (submitError) {
    <p class="submit-error" role="alert">{{ submitError }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button type="button" mat-dialog-close [disabled]="sending">Cancel</button>
  <button
    mat-raised-button
    color="warn"
    type="button"
    class="decline-submit-btn"
    (click)="submit()"
    [disabled]="!canSubmit">
    <span class="decline-submit-btn__content">
      @if (sending) {
        <mat-spinner diameter="20" class="decline-submit-spinner" />
        <span>Declining…</span>
      } @else {
        <span>Decline</span>
      }
    </span>
  </button>
</mat-dialog-actions>
